import React from 'react';

import { ApolloClient } from 'apollo-boost';

import {
  ForgeUIExtensionQueryOptions,
  useExtensionList,
} from '@atlassian/forge-ui/provider';

import { ForgeModuleType } from '../../types';
import { RenderForgeExtensions } from '../ForgeUIExtensionProviderWrapper/ForgeUIExtensionProviderWrapper';

interface ForgeUIExtensionsProps {
  moduleType: ForgeModuleType;
  render: RenderForgeExtensions;
  client: ApolloClient<object>;
  contextIds: string[];
  queryOptions?: ForgeUIExtensionQueryOptions;
}

export function ForgeUIExtensions({
  moduleType,
  render,
  client,
  contextIds,
  queryOptions,
}: ForgeUIExtensionsProps): React.ReactElement {
  const { extensions, loading, error } = useExtensionList({
    client,
    contextIds,
    type: moduleType,
    queryOptions,
  });

  return render(extensions, loading, error);
}
